import { DropdownOptionDTO, TabsDTO } from '../interface/app-common.interface';

export const ISSUES_TABS: TabsDTO[] = [
  { id: 'allIssues', label: 'All Issues', icon: '📄' },
  { id: 'filter', label: 'Filter', icon: '🔍' },
  { id: 'newIssue', label: 'New Issue', icon: '➕' },
  { id: 'existingIssue', label: 'New Adjustment', icon: '📂' },
];

export const ISSUES_DETAILED_PAGE_TABS: TabsDTO[] = [
  { id: 'issueInfo', label: 'Issue Info' },
  { id: 'incomePrior2018', label: 'Income / Credit Prior 2018' },
  { id: 'incomeAfter2017', label: 'Income / Credit After 2017' },
  { id: 'taxAccounting', label: 'Tax Accounting' },
  { id: 'auditPrior2018', label: 'Audit Updates - Prior 2018' },
  { id: 'auditAfter2017', label: 'Audit Updates - After 2017' },
];

export const CATEGORY_OPTIONS = [
  'A/M Issues for Domestic Operations',
  'Federal Tax',
  'State Tax',
  'International Tax',
];

export const ISSUE_IDS = ['1-0244', '1-0245', '1-0246'];

export const ENTITY_CODES = ['US001', 'US002', 'US003'];

export const YES_NO = ['Yes', 'No'];

export const ISSUE_STATUS = ['Open', 'In Progress', 'Pending', 'Closed'];

export const EXISTING_ISSUE_CONSTANT = {
  issueId: `IssueID`,
  description: `Description`,
  entityCode: `Entity Code`,
  issueYear: `Issue Year`,
  epAdjRequired: `E&P Adj Required`,
  contact: `Contact`,
  approver: `Approver`,
  tbbsAdjRequired: `TBBS Adj Required`,
  cfcNc902: `CFC/NC-902`,
  dateReviewed: `Date Reviewed`,
  dateCorptaxAdj: `Date Corptax Adj`,
  adjDescrip: `Adj. Descrip.`,
  arFilingId: `AR Filing ID`,
  arIssueId: `AR Issue ID`,
  irsIssueId: `IRS Issue ID`,
  saa: `SAA`,
  submission: `Submission`,
  spDocLink: `SP Doc Link`,
  npa: `NPA`,
  npaTiesToArSaa: `NPA ties to AR/SAA`,
  issueStatus: `Issue_Status`,
  select: `Select`,
  deduction199: `199 Deduction`,
  prior2018: `Prior 2018`,
  after2017: `After 2017`,
  auditPrior: `Audit Updates - Prior 2018`,
  auditAfter: `Audit Updates - After 2017`,
};

export const YES_NO_OPTIONS: DropdownOptionDTO[] = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];
